ScrollTrigger.matchMedia({
  "(min-width: 1199px)": function () {

var tl = gsap.timeline();
var ts = gsap.timeline();
let speed = 100;
gsap.to("[data-speed]", {
  y: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window) ,
  ease: "none",
  scrollTrigger: {
    start: 0,
    end: "max",
    invalidateOnRefresh: true,
    scrub: 0
  }
});
tl.fromTo(".heading_wpr", 0.5, { opacity: 0, scale: 0.7 },  { opacity: 1, scale: 1.0});
tl.fromTo(".mountain-box-1",{ opacity: 0, y: "100vh" },{ opacity: 1, y: "0vh", duration: 1 },0.75);
tl.fromTo(".mountain-box-2",{ opacity: 0, y: "100vh"  },{ opacity: 1, y: "0vh", duration: 1 },0.75);
  
tl.fromTo(".mountain-box-1-a",{ opacity: 0, y: "100vh" },{ opacity: 1, y: "0vh", duration: 2 },1);
tl.fromTo(".mountain-box-2-a",{ opacity: 0, y: "100vh" },{ opacity: 1, y: "0vh", duration: 2 },1); 

 tl.fromTo(".sun-box",
    { y: "0vh", scale: 0.75, opacity: 1 },
    {
      y: "-25vh" ,
      scale: 1.05,
      opacity: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: "#header-zoom",
         start: "top top",
        end: "300%",
        scrub: true
      }
    }
  );

  tl.fromTo(".banner-bggg-2",
    { opacity: 0 },
    {
      opacity: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: "#header-zoom",
         start: "top top",
        end: "bottom 50%",
        scrub: true
      }
    }
  );
 tl.fromTo(".sun-box", 1, { opacity: 0, scale: 0 }, { opacity: 1, scale: 0.75}); 
  
tl.fromTo(".rainbow-box--wrap",
    { y: "100vh" },
    {
      y: "40vh",
      scrollTrigger: {
        trigger: "#header-zoom",
        start: "top top",
        end: "bottom 50%",
        scrub: true
      }
    }
  );
 
tl.fromTo(".mountain-box-1, .mountain-box-2",
    { y: "0vh" },
    {
      y: "40vh",
      opacity: 0,
      scrollTrigger: {
        trigger: "#header-zoom",
         start: "bottom center",
         end: "+=200%",
        scrub: true
      }
    }
  );
  
  tl.fromTo(".mountain-box-1-a, .mountain-box-2-a",
    { y: "0vh" },
    {
      y: "80vh",
      scrollTrigger: {
        trigger: "#header-zoom",
         start: "bottom center",
         end: "+=120%",
        scrub: 2
      }
    }
  );
tl.fromTo(".wrap--bgg-in",
    { opacity: 0 },
    {
      opacity: 1,
      scrollTrigger: {
        trigger: "#header-zoom",
         start: "bottom center",
         end: "+=300%",
        scrub: true,
        toggleClass: { targets: ".index_banner_wrapper", className: "is-show" },
        onEnter: () => {
        document.querySelector(".index_banner_wrapper").classList.add("enter--show");
        },
        onLeaveBack: () => {
        document.querySelector(".index_banner_wrapper").classList.remove("enter--show");
       }
      }
    }
  );


tl.fromTo(
  ".index_banner_wrapper .heading_wpr .banner_heading",
  { color: "#007f99" }, // Starting color
  {
    color: "#fff",   // Ending color
    scrollTrigger: {
      trigger: "#header-zoom",
       start: "bottom center",
       end: "bottom top",
      scrub: 2
    }
  }
);

  

  

  tl.fromTo(".palm",
    { y: "120vh" },
    {
      y: "0vh",
      scrollTrigger: {
        trigger: "#header-zoom",
         start: "180% bottom",
         end: "+=400%", // longer scroll = slower feel
        scrub: true,
        toggleClass: { targets: ".index_banner_wrapper", className: "ppp" }
      }
    }
            
  );

  tl.fromTo(".waves--clip--1",
    { y: "100vh" },
    {
      y: "-25vh",
      scrollTrigger: {
        trigger: ".palm",
           start: "100% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );

    tl.fromTo(".waves--clip--2",
    { y: "100vh" },
    {
      y: "-23vh",
      scrollTrigger: {
        trigger: ".waves--clip--1",
           start: "150% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );

  tl.fromTo(".waves--clip--3",
    { y: "100vh" },
    {
      y: "-21vh",
      scrollTrigger: {
        trigger: ".waves--clip--2",
           start: "200% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );

  tl.fromTo(".waves--clip--4",
    { y: "100vh" },
    {
      y: "-19vh",
      scrollTrigger: {
        trigger: ".waves--clip--3",
           start: "250% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );

  tl.fromTo(".waves--clip--6",
    { y: "100vh" },
    {
      y: "-10vh",
      scrollTrigger: {
        trigger: ".waves--clip--4",
           start: "300% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );
  tl.fromTo(".waves--clip--7",
    { y: "100vh" },
    {
      y: "-15vh",
      scrollTrigger: {
        trigger: ".waves--clip--6",
           start: "350% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );
  tl.fromTo(".waves--clip--8",
    { y: "100vh" },
    {
      y: "-13vh",
      scrollTrigger: {
        trigger: ".waves--clip--7",
           start: "400% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );

   tl.fromTo(".waves--clip--9",
    { y: "100vh" },
    {
      y: "-11vh",
      scrollTrigger: {
        trigger: ".waves--clip--8",
           start: "450% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );
   tl.fromTo(".waves--clip--10",
    { y: "100vh" },
    {
      y: "-9vh",
      scrollTrigger: {
        trigger: ".waves--clip--9",
           start: "500% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );
  tl.fromTo(".waves--clip--11",
    { y: "100vh" },
    {
      y: "-9vh",
      scrollTrigger: {
        trigger: ".waves--clip--10",
           start: "550% center",
           end: "+=400%", // longer scroll = slower feel
        scrub: true
      }
    }
  );


  tl.fromTo(".indx--bott--wave",
    { y: "0" },
    {
      y: "-20vh",
      scrollTrigger: {
        trigger: ".waves--clip--1",
           start: "550% center",
           end: "+=500%", // longer scroll = slower feel
        scrub: true
      }
    }
  );


const timelineHeader = gsap.timeline({
  ease: "power2.out",
  scrollTrigger: {
    id: "fade",
    trigger: "#header-zoom",
    start: "top top",
    end: () => window.innerWidth < 1601 ? "+=660% 0" : "+=800% 0", // Adjust for smaller screens
    scrub: true,
    pin: true,
    toggleClass: { targets: "#header-zoom", className: "active" },
    invalidateOnRefresh: true, // Recalculate values on resize
    markers: false, // set to true for debugging
    invalidateOnRefresh: true,
  }
});
  
  timelineHeader
  .fromTo(".index-splide-slider-wrap--main",
      { y: 0 },
      { y: -50, ease: "power2.out", duration: 5 }
    );


  //reset scrollbar position after refresh
window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};
  }
});